<template>
  <div id="app">
    <v-app id="evaloe" v-if="$auth.ready()">
      <router-view name="navbar"></router-view>
      <router-view name="breadcrumbs"></router-view>
      <router-view name="content" v-on:showSnackbar="showSnackbar"></router-view>
      <v-snackbar
        :timeout="timeout"
        :top="y === 'top'"
        :bottom="y === 'bottom'"
        :right="x === 'right'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :vertical="mode === 'vertical'"
        color="error"
        v-model="show"
      >
        {{ $t('error_handling.'+text) }}
        <v-btn flat @click.native="show = false">Close</v-btn>
      </v-snackbar>
    </v-app>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data () {
      return {
        message: '',
        timeout: null,
        text: '',
        show: false,
        y: 'top',
        x: '',
        mode: ''
      }
    },
    methods: {
      showSnackbar (text, timeout = 6000, yPos = 'top', xPos, mode) {
        this.text = text
        this.timeout = timeout
        this.y = yPos
        this.x = xPos
        this.mode = mode
        this.show = true
      }
    }
  }
  console.log('Cargo App.vue')
</script>

<style>
.text-align-center {
  text-align: center;
}

.normal-p-font-size, p {
  font-size: large;
}
</style>



// WEBPACK FOOTER //
// src/App.vue